import { Component, Input } from '@angular/core';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { BankAccountInfoModel, BankAccountRequest, Currency, HxSupplierService } from 'hx-services';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NgFor, NgIf } from '@angular/common';
import { HxBankSelectComponent, HxEnumSelectComponent } from 'hx-component';
import { FormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-suppliers-bank',
    templateUrl: './suppliers-bank.component.html',
    styleUrls: ['./suppliers-bank.component.css'],
    imports: [NgIf, NgFor, HxBankSelectComponent, FormsModule, HxEnumSelectComponent, NgbTooltip, TranslocoPipe]
})
export class SuppliersBankComponent {
  list: BankAccountInfoModel[] = [];
  Currency = Currency;
  types = ['ACTUAL', 'LEGAL'];
  _id;
  @Input()
  set id(val) {
    this._id = val || null;
    if (val) {
      this.getList();
    }
  }
  get id() {
    return this._id;
  }
  isLoading = {
    list: false,
  };

  constructor(
    private supplierService: HxSupplierService,
    private toastr: HcToastrService,
    private tr: TranslocoService
  ) { }

  addItem() {
    this.list.push({bank: {}} as BankAccountInfoModel);
  }

  updateData(item: BankAccountInfoModel) {
    if (this.id) {
      const obj = {} as BankAccountRequest;
      obj.id = item.id;
      obj.bankId = item.bank?.id;
      obj.iban = item.iban;
      obj.beneficiaryCode = item.beneficiaryCode;
      obj.containerId = this.id;
      obj.currency = item.currency;
      let api = this.supplierService.saveSupplierBankAccount(this.id, obj).subscribe(
        () => {
          this.toastr.success(this.tr.translate('suppliers-bank.ts.saveSuccess'));
          this.getList();
        },
        () => {
          this.toastr.error(this.tr.translate('suppliers-bank.ts.error'));
        }
      );
    }
  }

  removeField(item, index) {
    if (item && item.id) {
      this.deleteItem(item.id);
    } else {
      this.list.splice(index, 1);
    }
  }

  private getList() {
    this.list = [];
    this.isLoading.list = true;

    this.supplierService.getSupplierBankAccountList(this.id).subscribe(
      result => {
        this.list = result || [];
        this.isLoading.list = false;
      },
      () => {
        this.isLoading.list = false;
      }
    );
  }

  private deleteItem(id) {
    if (id) {
      this.supplierService.removeSupplierBankAccount(this.id, id).subscribe(() => {
        this.toastr.success(this.tr.translate('suppliers-bank.ts.deleteBank'));
        this.getList();
      });
    }
  }
}
